import React, { useState, useMemo } from 'react';
import SolutionsHeader from './components/SolutionsHeader';
import QuestionNavigator from './components/QuestionNavigator';
import MainSolutionArea from './components/MainSolutionArea';
import PerformanceStats from './components/PerformanceStats';

const PracticeSolutions = ({ setShowResult, session }) => {
    console.log('session', session);

    const allQuestions = useMemo(() => {
        const sections = session?.sectionWise ?? [];
        if (!sections.length) return [];

        return sections.flatMap(section =>
            (section.questions ?? []).map(q => ({

                id: q.questionId,
                options: q.options,
                questionNo: q.questionNo,
                questionText: q.question,

                // attempt data
                userAnswer: q.selectedOption,
                isCorrect: q.isCorrect,
                isSkipped: q.isSkipped,
                isMarkedForReview: q.isMarkedForReview,

                subject: section.sectionName,
                explanation: q.explanation

            }))
        );

    }, [session?.sectionWise]);


    /**
     ✅ Active Question State
     */
    const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);


    /**
     ✅ Prevent Index Crash
     */
    const safeIndex = Math.min(activeQuestionIndex, allQuestions.length - 1);
    const activeQuestion = allQuestions[safeIndex] ?? null;
    console.log('activeQuestion', activeQuestion);

    /**
     ✅ LOADING STATE (VERY IMPORTANT)
     */
    if (!session?.sectionWise) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-[#F8F9FA]">
                <p className="text-lg font-semibold">
                    Preparing Solutions...
                </p>
            </div>
        );
    }

    /**
     ✅ EMPTY STATE
     */
    if (!allQuestions.length) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-[#F8F9FA]">
                <p className="text-lg font-semibold">
                    No Questions Found
                </p>
            </div>
        );
    }


    return (
        <div className="fixed inset-0 z-[100] bg-[#F8F9FA] overflow-y-auto font-inter">

            <SolutionsHeader onBack={() => setShowResult(false)} />

            <div className="w-full max-w-[1400px] mx-auto px-4 lg:px-6 py-8 flex flex-col lg:flex-row gap-6 items-start">

                <QuestionNavigator
                    questions={allQuestions}
                    activeIndex={safeIndex}
                    setActiveIndex={setActiveQuestionIndex}
                />

                <MainSolutionArea
                    question={activeQuestion}
                    currentIndex={safeIndex}
                    total={allQuestions.length}
                    setActiveIndex={setActiveQuestionIndex}
                />

                <PerformanceStats
                    overall={session?.overall ?? {}}
                    weakAreas={session?.weakAreas ?? []}
                />

            </div>
        </div>
    );
};

export default PracticeSolutions;
